import en from './en';
import ru from './ru';

export default {
  ru,
  en,
};
